// Centralized brand assets
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_pro-unlock-3/artifacts/mwm1rvv2_Influence%20Incubator.png";
export const BRAND_NAME = "Influence Incubator";
